// src/component/Loader.tsx

import React from "react";
import styled, { keyframes } from "styled-components";

// 스피너 애니메이션 정의
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// 로딩 컴포넌트 스타일 정의
const Spinner = styled.div`
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top: 5px solid #ffffff; /* 스피너 색상 */
  border-radius: 50%;
  width: 30px; /* 스피너 크기 */
  height: 30px; /* 스피너 크기 */
  animation: ${spin} 1s linear infinite;
`;

const Loader: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        position: "absolute",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
      }}
    >
      <Spinner />
    </div>
  );
};

export default Loader;
